<template>
    <div class="indicators-wrapper"></div>
</template>

<script>
    import { mapState } from 'vuex';
    import { 
        select as d3Select,
    } from 'd3';

    export default {
        name: "Indicators",
        props: ['content', 'storyActive'],
        computed: {
            ...mapState(['data']),
            paragraphsArr() {
                return this.content.stories[this.storyActive].paragraphs;
            },
            snippets() {
                return this.data.stories[this.storyActive].snippets;
            }
        },
        methods: {
            getScrollY() {
                this.paragraphsArr.forEach(p => {
                    if (p.id  != undefined) {
                        const paragraph = d3Select(`div#id-${p.id}`).node();
                        this.detectScrollTop(paragraph);
                    }
                })
            },
            detectScrollTop(elm) {
                const offsetTop = elm.getBoundingClientRect().top;

                if (offsetTop < 300 && offsetTop > 300 - elm.getBoundingClientRect().height) {
                    d3Select(elm).classed('highlighted', true);
                    this.resetTimer(elm)
                } else {
                    d3Select(elm).classed('highlighted', false);
                }
            },
            createIndicators() {
            }
        },
        mounted() {
            console.log(this.snippets);
        }    
    }
</script>

<style lang="scss">
    @import '../assets/style/main.scss';

    .indicators-wrapper {
        width: 10px;
        height: auto;
        border: 1px solid black;
    }
</style>


